import axios from "axios"

export const leaveConfigFlow = async (token, baseURL, userInfo, leave_type_id) => { //true = คนถัดไปคือผู้อนุมัติ
    let sendToFinal = false

    let flow1 = []
    let approve1 = null
    let flow2 = []
    let approve2 = {}
    try {
      const url = `${baseURL}/api/leave/config/flow/datatable`; //Flow ตาม org
          const params = new URLSearchParams({
              page: 1,
              size: 20,
              "order[0]": "users_position_id",
              "order[1]": "ASC",
              "filter[org_id][0]": userInfo?.cont_to_id,
              "filter[leave_type_id][0]": leave_type_id,
              "filter[status][0]": 1
          });
          const config = {
              headers: { Authorization: `Bearer ${token}` }, params
          };

          await axios.get(url, config).then(async response => {
            flow1 = response.data.result
            approve1 = response.data.result[0] ?? {}
          }).catch(error => console.error("Error:", error))
    } catch (err) {
    }

    try {
      const url = `${baseURL}/api/leave/config/flow/datatable`; //Flow ทั้งหมด
          const params = new URLSearchParams({
              page: 1,
              size: 20,
              "order[0]": "users_position_id",
              "order[1]": "ASC",
              "filter[org_id][0]": 0,
              "filter[leave_type_id][0]": leave_type_id,
              "filter[status][0]": 1
          });
          const config = {
              headers: { Authorization: `Bearer ${token}` }, params
          };

          await axios.get(url, config).then(async response => {
            flow2 = response.data.result
            approve2 = response.data.result[0] ?? {}
          }).catch(error => console.error("Error:", error))
    } catch (error) {}
    let flow = flow1.length > 0 ? flow1 : flow2
    let lastUserApprove = (approve1 && approve1?.users_position_id) ? approve1 : approve2

    if (userInfo?.leader.position_id <= lastUserApprove?.users_position_id) {
      sendToFinal = true
    }

    let result = { thisFlow: flow, lastUserApprove: lastUserApprove, sendToFinal: sendToFinal }
    return result
}